import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';

import { selectTrainerParam } from '../../users/usersSlice';
import useApiStatusDispatch from '../../../hooks/useApiStatusDispatch';
import { dateToAPIStandard, dateToYMD } from '../../../util/util';
import { Link, useHistory } from 'react-router-dom';
import DatePicker from "react-datepicker"
import { assignProgram } from '../../ProgramsAddEdit/ProgramsAddEditSlice';
import { getPrograms, selectAllPrograms } from '../../programs/programsSlice';
import { triggerCalendarRefetch, updatePrograms } from '../../../state/events';


const ProgramsModal = ({dispatchGetEvents}) => {

    // state for programs;
    const [isProgramsLoading, setIsProgramsLoading] = useState(false);
    const [programStartDate, setProgramStartDate] = useState(null);
    const [programDateError, setProgramDateError] = useState(false);
    const [programDraft, setProgramDraft] = useState(false);
    const [programSearch, setProgramSearch] = useState("");
    const [loadingProgramAdd, setLoadingProgramAdd] = useState([])

    const trainerParam = useSelector(selectTrainerParam)

    const dispatch = useDispatch();
    const statusDispatch = useApiStatusDispatch();

    const programs = useSelector(selectAllPrograms)

    const { selectedClient: client_id } = useSelector(state => (state.allEvents.selectedEventInfo))

    const {show: programsShow, status} = useSelector(state => (state.allEvents.programs))

    //add programs modal useEffect
    useEffect(() => {
        if (programsShow && status ==="init") {
            setIsProgramsLoading(true);
            dispatch(getPrograms()).then((res) => {
                setIsProgramsLoading(false);
            })
            dispatch(updatePrograms({status:"idle"}))
        } 
    }, [programsShow, status])



    function handleAddProgram(program_id) {
        if (!programStartDate) {
            setProgramDateError(true)
            return;
        } else {
            setProgramDateError(false)
        };

        setLoadingProgramAdd(prev => [...prev, program_id]);

        let payload = {
            assign_to_all: 0,
            assign_by_tag: 0,
            match_exactly: 0,
            client_ids: [client_id],
            start_date: dateToYMD(programStartDate),
            program_id,
            publish: programDraft ? "0" : "1"
        }
        statusDispatch(assignProgram(payload), "program", "assign")
            .then(res => {
                setLoadingProgramAdd(prev => prev.filter(item => item != program_id));
                dispatchGetEvents();
                dispatch(triggerCalendarRefetch({refetch: true}))
            })
    }

    const draftInfoText = () => {
        return (
            <>
                Assign as draft
                <OverlayTrigger
                    placement={"top"}
                    overlay={
                        <Tooltip>
                            <p>All workouts, tasks, and nutrition in program will be assigned to client as drafts</p>
                        </Tooltip>
                    }
                >
                    <i className="ml-1 fas fa-info-circle" />
                </OverlayTrigger>
            </>
        )
    }

    function filterProgram(item) {
        let cleanedQuery = programSearch.toLowerCase().trim();
        if (cleanedQuery.length > 0) {
            return item.programName.toLowerCase().includes(cleanedQuery) ||
                item.programNotes.toLowerCase().includes(cleanedQuery);
        } else {
            return true
        }
    }

    function Program({ program }) {
        return (

            <div className="d-flex justify-content-between">
                <div style={{ maxWidth: "550px" }}>
                    <b>
                        {program.programName}
                    </b> ({program.programLength} days)
                    <div className="mt-2 ml-2">
                        {program.programNotes}
                    </div>
                </div>
                <div style={{ minWidth: "120px" }}>
                    <Link className="mr-2" to={`/program-editor/?id=${program.programID}&${trainerParam}`}>
                        <Button size="sm" variant="outline-success">
                            View
                        </Button>
                    </Link>

                    <Button size="sm"
                        disabled={loadingProgramAdd.includes(program.programID)}
                        onClick={() => handleAddProgram(program.programID)}>
                        {loadingProgramAdd.includes(program.programID) ?
                            <Spinner size="sm" animation="border" /> :
                            "Add"}
                    </Button>
                </div>
            </div>)
    }




    {/* add Programs */ }
    return (
        <Modal
            size="lg"
            show={programsShow}
            onHide={() => {
                dispatch(updatePrograms({ show: !programsShow }));
                setProgramDateError(false)
            }}
            style={{ display: 'flex !important', flexDirection: 'column', alignItems: 'center' }}
        >
            <Modal.Header className="w-100 mb-2 " closeButton>
                <Modal.Title>
                    Add Program <Button
						as={Link}
						className="ml-1"
						variant="outline-primary"
						to={`/programs?${trainerParam}`}
						size="sm"
					>
						Manage Programs
					</Button>
                </Modal.Title>
            </Modal.Header>


            <Modal.Body style={{ width: '100%' }}>
                <div className="mb-4">
                    <div className="mb-1">
                        Program Start Date:
                        <DatePicker
                            className="mb-2 ml-2 text-center"
                            selected={programStartDate}
                            onChange={(date) => { setProgramStartDate(date); setProgramDateError(false) }}
                            dateFormat="EEE, MMM d, yyyy"
                        />
                        <div>
                            {programDateError && <small className="text-danger"> program start date required</small>}
                        </div>
                    </div>

                    <Form.Check
                        className="mt-2"
                        label={(draftInfoText())}
                        value={programDraft}
                        onChange={e => {
                            setProgramDraft(prev => !prev)
                        }}
                        name="eventsAsDrafts"
                        id="eventsAsDrafts"
                        type="checkbox"
                    />
                </div>

                <hr style={{ height: "1px", background: "grey" }} />
                <Form.Control
                    className="mb-3"
                    placeholder="search programs"
                    value={programSearch}
                    onChange={(e) => setProgramSearch(e.target.value)}
                />
                {isProgramsLoading ? <Spinner animation="border" variant="primary" />
                    : <div style={{ height: "400px", overflow: "auto" }}>
                        {programs?.filter(filterProgram).map(program => {
                            return (
                                <>
                                    <Program program={program} />
                                    <hr />
                                </>
                            )
                        })}
                    </div>}
            </Modal.Body>
        </Modal>
    )
}

export default ProgramsModal